import React, { ChangeEventHandler } from 'react'
import { useWindowSize } from '../../../../hooks/useWindowSize'
import { styled } from '../../../../lib/stitches'
import { Box, Spacer } from '../../../core/Components'
import { Flex } from '../../../core/Flex'
import ProfileCard from '../../../platform/dashboard/ProfileCard'
import { useSearch } from '../hooks/useSearch'
import SearchBar from './SearchBar'
import Tabs from './Tabs'
import Title from './Title'

const HeaderContainer = styled('div', {
  boxSizing: 'border-box',
  borderBottom: '1px solid rgba(0,0,0,.1)'
})

interface Props {
  isSticky?: boolean
}

const Header = React.forwardRef<HTMLDivElement, Props>(({ isSticky }, ref) => {
  const { isBreakpoint } = useWindowSize()
  const [search, setSearch] = useSearch()

  const handleInput: ChangeEventHandler<HTMLInputElement> = (evt) => {
    setSearch(evt.target.value)
  }

  if (isBreakpoint('mobile'))
    return (
      <HeaderContainer
        css={{
          height: '86px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: isSticky ? 'sticky' : 'inherit',
          zIndex: isSticky ? 10 : 1,
          top: 0
        }}
        ref={ref}
      >
        <Box css={{ display: 'flex', alignItems: 'center', flex: 1, height: '100%' }}>
          <Title css={{ marginRight: '32px', marginBottom: '16px' }}>Explore</Title>
          <Tabs.List css={{ marginRight: '32px', height: '100%' }}>
            <Tabs.Trigger value={'songs'}>Songs</Tabs.Trigger>
            <Tabs.Trigger value={'sounds'}>Sounds</Tabs.Trigger>
            <Tabs.Trigger value={'packs'}>Packs</Tabs.Trigger>
          </Tabs.List>
          <SearchBar css={{ flex: 1, maxWidth: '500px' }} onChange={handleInput} value={search} />
          <Spacer />
          {isSticky && <ProfileCard css={{ marginLeft: '$32' }} />}
        </Box>
      </HeaderContainer>
    )

  return (
    <HeaderContainer
      css={{
        position: isSticky ? 'sticky' : 'inherit',
        top: 0,
        zIndex: isSticky ? 10 : 1,
        marginBottom: '16px'
      }}
      ref={ref}
    >
      <Flex>
        <Title>Explore</Title>
        <Spacer />
        {isSticky && <ProfileCard css={{ marginLeft: '$32' }} />}
      </Flex>
      <SearchBar onChange={handleInput} value={search} />
      <Tabs.List css={{ marginTop: '8px' }}>
        <Tabs.Trigger value={'songs'}>Songs</Tabs.Trigger>
        <Tabs.Trigger value={'sounds'}>Sounds</Tabs.Trigger>
        <Tabs.Trigger value={'packs'}>Packs</Tabs.Trigger>
      </Tabs.List>
    </HeaderContainer>
  )
})

export default Header
